import Vue from 'vue';

export default {
    getEducationLevel({ dispatch }) {
        return dispatch('getAttributes', { code: 'education_level' });
    },

    getWorkAuthorisation({ dispatch }) {
        return dispatch('getAttributes', { code: 'work_authorisation' });
    },

    getCareerLevel({ dispatch }) {
        return dispatch('getAttributes', { code: 'career_level' });
    },

    getNoticePeriod({ dispatch }) {
        return dispatch('getAttributes', { code: 'notice_period' });
    },

    getJobType({ dispatch }) {
        return dispatch('getAttributes', { code: 'job_type' });
    },

    getContractType({ dispatch }) {
        return dispatch('getAttributes', { code: 'contract_type' });
    },

    getSkills({ dispatch }, keyword) {
        return dispatch('getAttributes', { code: 'skills', keyword });
    },

    getSector({ dispatch }) {
        return dispatch('getAttributes', { code: 'sector' });
    },

    getCompanySize({ dispatch }) {
        return dispatch('getAttributes', { code: 'company_size' });
    },

    getIndustry({ dispatch }) {
        return dispatch('getAttributes', { code: 'industry' });
    },

    getJobMode({ dispatch }) {
        return dispatch('getAttributes', { code: 'job_mode' });
    },

    getEmergencyRel({ dispatch }) {
        return dispatch('getAttributes', { code: 'emergency_contact_rel' });
    },

    getAttributes(context, { code, keyword }) {
        // TODO - fetch all the attributes in one call.
        let url = `v1/attributes/options?code=${code}`;
        if (keyword) {
            url += `&keyword=${keyword}`;
        }
        return Vue.$axios.$get(url);
    },

    searchAttributes(context, { code, keyword }) {
        const url = `v1/search-attribute-options?code=${code}&keyword=${keyword}`;
        return Vue.$axios.$get(url);
    },

    getSiteAttributes() {
        let url = 'v1/site/attributes';
        return Vue.$axios.$get(url);
    },
};
